[
  {
    "identifyExtra": "extra"
  },

  {
    "name": "BRBarbearia",
    "identify": "brbarbearia",
    "urlApi": "https://brbarbearia.vulcan.net.br",
    "applicationCode": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJCUiBCQVJCRUFSSUEgRlJBTlFVRUFET1JBIExUREEiLCJzdWIiOiJCUiBCQVJCRUFSSUEiLCJpYXQiOjE3ODA1MDUxOTEsImV4cCI6MTc4MDUwNTE5MSwianRpIjoxNzgwNTA1MTkxMTIzLCJhdWQiOiJicmJhcmJlYXJpYSJ9.GGhrdKWH5QV5ZJf1HClP9k899XTFz11tICBqzAF6xPc",
    "logo_empresa": "https://cdn-vulcan-us.s3.amazonaws.com/brbarbearia/logo_empresa.png",
    "logo_empresa_light": "https://cdn-vulcan-us.s3.amazonaws.com/brbarbearia/logo_empresa.png",
    "logo_empresa_dark": "https://cdn-vulcan-us.s3.amazonaws.com/brbarbearia/logo_empresa.png",
    "logo_empresa_small_light": "https://cdn-vulcan-us.s3.amazonaws.com/brbarbearia/logo_empresa.png",
    "logo_empresa_small_dark": "https://cdn-vulcan-us.s3.amazonaws.com/brbarbearia/logo_empresa.png",
    "favicon": "https://cdn-vulcan-us.s3.amazonaws.com/brbarbearia/favico_empresa.ico",
    "cover_login": "https://cdn-vulcan-us.s3.amazonaws.com/cartopay/cover_login.png",
    "gTagManager": "",
    "idHOTJAR": "",
    "appVersion": "0.0.1",
    "primaryColor": "#A4ED00",
    "secondaryColor": "#002C5D",
    "tertiaryColor": "#343a40",
    "quaternaryColor": "#f8f9fa",
    "successColor": "#28a745",
    "infoColor": "#17a2b8",
    "warningColor": "#ffc107",
    "dangerColor": "#dc3545",
    "url_facebook": "",
    "url_instagram": "",
    "url_linkedin": "",
    "ambient": "P"
  },

  {
    "name": "CartoPay",
    "identify": "cartopay",
    "urlApi": "https://cartopay.vulcan.net.br",
    "applicationCode": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJDQVJUTyBGSU5URUNIIEUgRlJBTkNISVNJTkcgTFREQSIsInN1YiI6IkNBUlRPIiwiaWF0IjoxNzgwNTA1MjgwLCJleHAiOjE3ODA1MDUyODAsImp0aSI6MTc4MDUwNTI4MDEyMywiYXVkIjoiY2FydG9wYXkifQ.yshGeCWsyN8FDCrIOHwjErXsxoQAfQJE_J3d6EJagnE",
    "logo_empresa": "https://cdn-vulcan-us.s3.amazonaws.com/cartopay/logo_empresa.png",
    "logo_empresa_light": "https://cdn-vulcan-us.s3.amazonaws.com/cartopay/logo_empresa.png",
    "logo_empresa_dark": "https://cdn-vulcan-us.s3.amazonaws.com/cartopay/logo_empresa.png",
    "logo_empresa_small_light": "https://cdn-vulcan-us.s3.amazonaws.com/cartopay/logo_empresa.png",
    "logo_empresa_small_dark": "https://cdn-vulcan-us.s3.amazonaws.com/cartopay/logo_empresa.png",
    "favicon": "https://cdn-vulcan-us.s3.amazonaws.com/cartopay/favico_empresa.ico",
    "cover_login": "https://cdn-vulcan-us.s3.amazonaws.com/cartopay/cover_login.png",
    "gTagManager": "",
    "idHOTJAR": "",
    "appVersion": "0.0.1",
    "primaryColor": "#259984",
    "secondaryColor": "#002C5D",
    "tertiaryColor": "#343a40",
    "quaternaryColor": "#f8f9fa",
    "successColor": "#28a745",
    "infoColor": "#17a2b8",
    "warningColor": "#ffc107",
    "dangerColor": "#dc3545",
    "url_facebook": "",
    "url_instagram": "",
    "url_linkedin": "",
    "ambient": "P"
  },

  {
    "name": "Connect",
    "identify": "connect",
    "urlApi": "https://connect.vulcan.net.br",
    "applicationCode": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJDT05ORUNUIElORk9STUFcdTAwYzdcdTAwZDVFUyBFIFRFQ05PTE9HSUEgUy9BIiwic3ViIjoiQ09OTkVDVCIsImlhdCI6MTc4MDUwNTM5NCwiZXhwIjoxNzgwNTA1Mzk0LCJqdGkiOjE3ODA1MDUzOTQxMjMsImF1ZCI6ImNvbm5lY3QifQ.iZRzBkZH_SS70jxyGWfKZCCTzKbF3FfK8usIfCylElQ",
    "logo_empresa": "https://cdn-vulcan-us.s3.amazonaws.com/connect/logo_empresa.png",
    "logo_empresa_light": "https://cdn-vulcan-us.s3.amazonaws.com/connect/logo_empresa.png",
    "logo_empresa_dark": "https://cdn-vulcan-us.s3.amazonaws.com/connect/logo_empresa.png",
    "logo_empresa_small_light": "https://cdn-vulcan-us.s3.amazonaws.com/connect/logo_empresa.png",
    "logo_empresa_small_dark": "https://cdn-vulcan-us.s3.amazonaws.com/connect/logo_empresa.png",
    "favicon": "https://cdn-vulcan-us.s3.amazonaws.com/connect/favico_empresa.ico",
    "cover_login": "https://cdn-vulcan-us.s3.amazonaws.com/cartopay/cover_login.png",
    "gTagManager": "G-F6KR6MM06H",
    "idHOTJAR": "",
    "appVersion": "0.0.1",
    "primaryColor": "#009a84",
    "secondaryColor": "#002C5D",
    "tertiaryColor": "#343a40",
    "quaternaryColor": "#f8f9fa",
    "successColor": "#28a745",
    "infoColor": "#17a2b8",
    "warningColor": "#ffc107",
    "dangerColor": "#dc3545",
    "url_facebook": "",
    "url_instagram": "",
    "url_linkedin": "",
    "ambient": "P"
  },

  {
    "name": "EasyPagg",
    "identify": "easypagg",
    "urlApi": "https://easypagg.vulcan.net.br",
    "applicationCode": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJFQVNZIFBBR0cgRklOVEVDSCBMVERBIiwic3ViIjoiRUFTWSBQQUdHIiwiaWF0IjoxNzgwNTA1NTQ3LCJleHAiOjE3ODA1MDU1NDcsImp0aSI6MTc4MDUwNTU0NzEyMywiYXVkIjoiZWFzeXBhZ2cifQ.putQZ5ds71DUm5RcER5rDAp1_XDmQWk6-qe7_5wWKDM",
    "logo_empresa": "https://cdn-vulcan-us.s3.amazonaws.com/easypagg/logo_empresa.png",
    "logo_empresa_light": "https://cdn-vulcan-us.s3.amazonaws.com/easypagg/logo_empresa.png",
    "logo_empresa_dark": "https://cdn-vulcan-us.s3.amazonaws.com/easypagg/logo_empresa.png",
    "logo_empresa_small_light": "https://cdn-vulcan-us.s3.amazonaws.com/easypagg/logo_empresa.png",
    "logo_empresa_small_dark": "https://cdn-vulcan-us.s3.amazonaws.com/easypagg/logo_empresa.png",
    "favicon": "https://cdn-vulcan-us.s3.amazonaws.com/easypagg/favico_empresa.ico",
    "cover_login": "https://cdn-vulcan-us.s3.amazonaws.com/cartopay/cover_login.png",
    "gTagManager": "",
    "idHOTJAR": "",
    "appVersion": "0.0.1",
    "primaryColor": "#22274D",
    "secondaryColor": "#002C5D",
    "tertiaryColor": "#343a40",
    "quaternaryColor": "#f8f9fa",
    "successColor": "#28a745",
    "infoColor": "#17a2b8",
    "warningColor": "#ffc107",
    "dangerColor": "#dc3545",
    "url_facebook": "",
    "url_instagram": "",
    "url_linkedin": "",
    "ambient": "P"
  },

  {
    "name": "EasyPay",
    "identify": "easypay",
    "urlApi": "https://easypay.vulcan.net.br",
    "applicationCode": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJFQVNZUEFZIFBBR0FNRU5UT1MgRSBTRVJWSUNPUyBMVERBIiwic3ViIjoiRUFTWVBBWSIsImlhdCI6MTc4MDUwNTY0MywiZXhwIjoxNzgwNTA1NjQzLCJqdGkiOjE3ODA1MDU2NDMxMjMsImF1ZCI6ImVhc3lwYXkifQ.5rc5H-k-pEyenV9wjZWe47oOJ9BrHAu3Q-igWZ8h1nI",
    "logo_empresa": "https://cdn-vulcan-us.s3.amazonaws.com/easypay/logo_empresa.png",
    "logo_empresa_light": "https://cdn-vulcan-us.s3.amazonaws.com/easypay/logo_empresa.png",
    "logo_empresa_dark": "https://cdn-vulcan-us.s3.amazonaws.com/easypay/logo_empresa.png",
    "logo_empresa_small_light": "https://cdn-vulcan-us.s3.amazonaws.com/easypay/logo_empresa.png",
    "logo_empresa_small_dark": "https://cdn-vulcan-us.s3.amazonaws.com/easypay/logo_empresa.png",
    "favicon": "https://cdn-vulcan-us.s3.amazonaws.com/easypay/favico_empresa.ico",
    "cover_login": "https://www.easypay.com.br/images/easypay-logo-full.png",
    "gTagManager": "",
    "idHOTJAR": "",
    "appVersion": "0.0.1",
    "primaryColor": "#0000CC",
    "secondaryColor": "#002C5D",
    "tertiaryColor": "#343a40",
    "quaternaryColor": "#f8f9fa",
    "successColor": "#28a745",
    "infoColor": "#17a2b8",
    "warningColor": "#ffc107",
    "dangerColor": "#dc3545",
    "url_facebook": "",
    "url_instagram": "",
    "url_linkedin": "",
    "ambient": "P"
  },

  {
    "name": "FALKPAY",
    "identify": "falkpay",
    "urlApi": "https://falkpay.vulcan.net.br",
    "applicationCode": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJDT05ORUNUIElORk9STUFcdTAwYzdcdTAwZDVFUyBFIFRFQ05PTE9HSUEgUy9BIiwic3ViIjoiQ09OTkVDVCIsImlhdCI6MTc4MDUwNTQ4MCwiZXhwIjoxNzgwNTA1NDgwLCJqdGkiOjE3ODA1MDU0ODAxMjMsImF1ZCI6ImZhbGtwYXkifQ.AQYLgak_MoNPfu8TeB5JWCRTYhSBOlGjL3etpHyNnyU",
    "logo_empresa": "https://cdn-vulcan-us.s3.amazonaws.com/falkpay/logo_empresa.png",
    "logo_empresa_light": "https://cdn-vulcan-us.s3.amazonaws.com/falkpay/logo_empresa.png",
    "logo_empresa_dark": "https://cdn-vulcan-us.s3.amazonaws.com/falkpay/logo_empresa.png",
    "logo_empresa_small_light": "https://cdn-vulcan-us.s3.amazonaws.com/falkpay/logo_empresa.png",
    "logo_empresa_small_dark": "https://cdn-vulcan-us.s3.amazonaws.com/falkpay/logo_empresa.png",
    "favicon": "https://cdn-vulcan-us.s3.amazonaws.com/falkpay/favico_empresa.ico",
    "cover_login": "https://cdn-vulcan-us.s3.amazonaws.com/cartopay/cover_login.png",
    "gTagManager": "",
    "idHOTJAR": "",
    "appVersion": "0.0.1",
    "primaryColor": "#000000",
    "secondaryColor": "#002C5D",
    "tertiaryColor": "#343a40",
    "quaternaryColor": "#f8f9fa",
    "successColor": "#28a745",
    "infoColor": "#17a2b8",
    "warningColor": "#ffc107",
    "dangerColor": "#dc3545",
    "url_facebook": "",
    "url_instagram": "",
    "url_linkedin": "",
    "ambient": "P"
  },

  {
    "name": "L2A",
    "identify": "l2a",
    "urlApi": "https://l2a.vulcan.net.br",
    "applicationCode": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJMMkEgQ09OU1VMVE9SSUEgRU0gR0VTVEFPIExUREEiLCJzdWIiOiJMMkEiLCJpYXQiOjE3ODA1MDU3NzUsImV4cCI6MTc4MDUwNTc3NSwianRpIjoxNzgwNTA1Nzc1MTIzLCJhdWQiOiJsMmEifQ.mG1xp4EEF6_ccs7yIBrGupj_T106tRPKjw4SHs2YhLI",
    "logo_empresa": "https://cdn-vulcan-us.s3.amazonaws.com/l2a/logo_empresa.png",
    "logo_empresa_light": "https://cdn-vulcan-us.s3.amazonaws.com/l2a/logo_empresa.png",
    "logo_empresa_dark": "https://cdn-vulcan-us.s3.amazonaws.com/l2a/logo_empresa.png",
    "logo_empresa_small_light": "https://cdn-vulcan-us.s3.amazonaws.com/l2a/logo_empresa.png",
    "logo_empresa_small_dark": "https://cdn-vulcan-us.s3.amazonaws.com/l2a/logo_empresa.png",
    "favicon": "https://cdn-vulcan-us.s3.amazonaws.com/l2a/favico_empresa.ico",
    "cover_login": "https://cdn-vulcan-us.s3.amazonaws.com/cartopay/cover_login.png",
    "gTagManager": "",
    "idHOTJAR": "",
    "appVersion": "0.0.1",
    "primaryColor": "#18234c",
    "secondaryColor": "#002C5D",
    "tertiaryColor": "#343a40",
    "quaternaryColor": "#f8f9fa",
    "successColor": "#28a745",
    "infoColor": "#17a2b8",
    "warningColor": "#ffc107",
    "dangerColor": "#dc3545",
    "url_facebook": "",
    "url_instagram": "",
    "url_linkedin": "",
    "ambient": "P"
  },

  {
    "name": "Maqplan",
    "identify": "maqplan",
    "urlApi": "https://maqplan.vulcan.net.br",
    "applicationCode": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJUT1RBTCBBVVRPTUFDQU8gRSBTT0ZUV0FSRSBMVERBIiwic3ViIjoiTUFRUExBTiIsImlhdCI6MTc4MDUwNTg0NywiZXhwIjoxNzgwNTA1ODQ3LCJqdGkiOjE3ODA1MDU4NDcxMjMsImF1ZCI6Im1hcXBsYW4ifQ.1wseWIESXDskhLDV6B9s52JrSoZ26L96sHqhSlFr7wQ",
    "logo_empresa": "https://cdn-vulcan-us.s3.amazonaws.com/maqplan/logo_empresa.png",
    "logo_empresa_light": "https://cdn-vulcan-us.s3.amazonaws.com/maqplan/logo_empresa.png",
    "logo_empresa_dark": "https://cdn-vulcan-us.s3.amazonaws.com/maqplan/logo_empresa.png",
    "logo_empresa_small_light": "https://cdn-vulcan-us.s3.amazonaws.com/maqplan/logo_empresa.png",
    "logo_empresa_small_dark": "https://cdn-vulcan-us.s3.amazonaws.com/maqplan/logo_empresa.png",
    "favicon": "https://cdn-vulcan-us.s3.amazonaws.com/maqplan/favico_empresa.ico",
    "cover_login": "https://cdn-vulcan-us.s3.amazonaws.com/cartopay/cover_login.png",
    "gTagManager": "",
    "idHOTJAR": "",
    "appVersion": "0.0.1",
    "primaryColor": "#538bc8",
    "secondaryColor": "#002C5D",
    "tertiaryColor": "#343a40",
    "quaternaryColor": "#f8f9fa",
    "successColor": "#28a745",
    "infoColor": "#17a2b8",
    "warningColor": "#ffc107",
    "dangerColor": "#dc3545",
    "url_facebook": "",
    "url_instagram": "",
    "url_linkedin": "",
    "ambient": "P"
  },

  {
    "name": "MAQZERO",
    "identify": "maqzero",
    "urlApi": "https://vision.vulcan.net.br",
    "applicationCode": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJKVU5UT1MgTkVHXHUwMGQzQ0lPUyBFIEZSQU5DSElTTkcgTFREQSIsInN1YiI6IkpVTlRPUyIsImlhdCI6MTc4MDQ5MDk3MiwiZXhwIjoxNzgwNDkwOTcyLCJqdGkiOjE3ODA0OTA5NzIxMjMsImF1ZCI6InZpc2lvbiJ9.Byh2yUxBBJo30a-lo8rybKBqQMIMi5adWP_uEty5ew0",
    "logo_empresa": "https://cdn-vulcan-us.s3.amazonaws.com/vision/logo_empresa_maqzero.png",
    "logo_empresa_light": "https://cdn-vulcan-us.s3.amazonaws.com/vision/logo_empresa_maqzero.png",
    "logo_empresa_dark": "https://cdn-vulcan-us.s3.amazonaws.com/vision/logo_empresa_maqzero.png",
    "logo_empresa_small_light": "https://cdn-vulcan-us.s3.amazonaws.com/vision/logo_empresa_maqzero.png",
    "logo_empresa_small_dark": "https://cdn-vulcan-us.s3.amazonaws.com/vision/logo_empresa_maqzero.png",
    "favicon": "https://cdn-vulcan-us.s3.amazonaws.com/vision/favico_empresa.ico",
    "cover_login": "https://cdn-vulcan-us.s3.amazonaws.com/cartopay/cover_login.png",
    "gTagManager": "",
    "idHOTJAR": "",
    "appVersion": "0.0.1",
    "primaryColor": "#014fd8",
    "secondaryColor": "#002C5D",
    "tertiaryColor": "#343a40",
    "quaternaryColor": "#f8f9fa",
    "successColor": "#28a745",
    "infoColor": "#17a2b8",
    "warningColor": "#ffc107",
    "dangerColor": "#dc3545",
    "url_facebook": "",
    "url_instagram": "",
    "url_linkedin": "",
    "ambient": "P"
  },

  {
    "name": "MONETTO PAY",
    "identify": "monettopay",
    "urlApi": "https://monettopay.vulcan.net.br",
    "applicationCode": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiI1OC4wMDYuMDQxIEpBSU5FIE1JVFRNQU5OIiwic3ViIjoiTU9ORVRUTyIsImlhdCI6MTc4MDUwNTg5OSwiZXhwIjoxNzgwNTA1ODk5LCJqdGkiOjE3ODA1MDU4OTkxMjMsImF1ZCI6Im1vbmV0dG9wYXkifQ.fjPCwqCxVKNhOU6TLpQalvGQycEIJV2yX_8CePjqKiI",
    "logo_empresa": "https://cdn-vulcan-us.s3.amazonaws.com/monettopay/logo_empresa.png",
    "logo_empresa_light": "https://cdn-vulcan-us.s3.amazonaws.com/monettopay/logo_empresa.png",
    "logo_empresa_dark": "https://cdn-vulcan-us.s3.amazonaws.com/monettopay/logo_empresa.png",
    "logo_empresa_small_light": "https://cdn-vulcan-us.s3.amazonaws.com/monettopay/logo_empresa.png",
    "logo_empresa_small_dark": "https://cdn-vulcan-us.s3.amazonaws.com/monettopay/logo_empresa.png",
    "favicon": "https://cdn-vulcan-us.s3.amazonaws.com/monettopay/favico_empresa.ico",
    "cover_login": "https://cdn-vulcan-us.s3.amazonaws.com/cartopay/cover_login.png",
    "gTagManager": "",
    "idHOTJAR": "",
    "appVersion": "0.0.1",
    "primaryColor": "#E2F26B",
    "secondaryColor": "#002C5D",
    "tertiaryColor": "#343a40",
    "quaternaryColor": "#f8f9fa",
    "successColor": "#28a745",
    "infoColor": "#17a2b8",
    "warningColor": "#ffc107",
    "dangerColor": "#dc3545",
    "url_facebook": "",
    "url_instagram": "",
    "url_linkedin": "",
    "ambient": "P"
  },

  {
    "name": "Ncard",
    "identify": "ncard",
    "urlApi": "https://ncard.vulcan.net.br",
    "applicationCode": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJOQ0FSRCBTRVJWSVx1MDBjN09TIEUgTkVHXHUwMGQzQ0lPUyBMVERBIiwic3ViIjoiTkNBUkQiLCJpYXQiOjE3ODA1MDU5NTcsImV4cCI6MTc4MDUwNTk1NywianRpIjoxNzgwNTA1OTU3MTIzLCJhdWQiOiJuY2FyZCJ9.F4K_MPfLVIoGVljWOIr2b36sFYexaBr7zrEjb4Sktdc",
    "logo_empresa": "https://cdn-vulcan-us.s3.amazonaws.com/ncard/logo_empresa.png",
    "logo_empresa_light": "https://cdn-vulcan-us.s3.amazonaws.com/ncard/logo_empresa.png",
    "logo_empresa_dark": "https://cdn-vulcan-us.s3.amazonaws.com/ncard/logo_empresa.png",
    "logo_empresa_small_light": "https://cdn-vulcan-us.s3.amazonaws.com/ncard/logo_empresa.png",
    "logo_empresa_small_dark": "https://cdn-vulcan-us.s3.amazonaws.com/ncard/logo_empresa.png",
    "favicon": "https://cdn-vulcan-us.s3.amazonaws.com/ncard/favico_empresa.ico",
    "cover_login": "https://cdn-vulcan-us.s3.amazonaws.com/cartopay/cover_login.png",
    "gTagManager": "",
    "idHOTJAR": "",
    "appVersion": "0.0.1",
    "primaryColor": "#26eb26",
    "secondaryColor": "#002C5D",
    "tertiaryColor": "#343a40",
    "quaternaryColor": "#f8f9fa",
    "successColor": "#28a745",
    "infoColor": "#17a2b8",
    "warningColor": "#ffc107",
    "dangerColor": "#dc3545",
    "url_facebook": "",
    "url_instagram": "",
    "url_linkedin": "",
    "ambient": "P"
  },

  {
    "name": "Otimiza",
    "identify": "otimiza",
    "urlApi": "https://otimiza.vulcan.net.br",
    "applicationCode": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJPVElNSVpBIENBUElUQUwgTFREQSIsInN1YiI6Ik9USU1JWkEiLCJpYXQiOjE3ODA1MDYwMTcsImV4cCI6MTc4MDUwNjAxNywianRpIjoxNzgwNTA2MDE3MTIzLCJhdWQiOiJvdGltaXphIn0.za9yiwnd6Nnp_SEa6CNYebI62F8Wz5j--l-S9sjEXJ0",
    "logo_empresa": "https://cdn-vulcan-us.s3.amazonaws.com/otimiza/logo_empresa.png",
    "logo_empresa_light": "https://cdn-vulcan-us.s3.amazonaws.com/otimiza/logo_empresa.png",
    "logo_empresa_dark": "https://cdn-vulcan-us.s3.amazonaws.com/otimiza/logo_empresa.png",
    "logo_empresa_small_light": "https://cdn-vulcan-us.s3.amazonaws.com/otimiza/logo_empresa.png",
    "logo_empresa_small_dark": "https://cdn-vulcan-us.s3.amazonaws.com/otimiza/logo_empresa.png",
    "favicon": "https://cdn-vulcan-us.s3.amazonaws.com/otimiza/favico_empresa.ico",
    "cover_login": "https://cdn-vulcan-us.s3.amazonaws.com/cartopay/cover_login.png",
    "gTagManager": "",
    "idHOTJAR": "",
    "appVersion": "0.0.1",
    "primaryColor": "#0285EF",
    "secondaryColor": "#002C5D",
    "tertiaryColor": "#343a40",
    "quaternaryColor": "#f8f9fa",
    "successColor": "#28a745",
    "infoColor": "#17a2b8",
    "warningColor": "#ffc107",
    "dangerColor": "#dc3545",
    "url_facebook": "",
    "url_instagram": "",
    "url_linkedin": "",
    "ambient": "P"
  },

  {
    "name": "Remax",
    "identify": "remax",
    "urlApi": "https://vision.vulcan.net.br",
    "applicationCode": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJKVU5UT1MgTkVHXHUwMGQzQ0lPUyBFIEZSQU5DSElTTkcgTFREQSIsInN1YiI6IkpVTlRPUyIsImlhdCI6MTc4MDQ5MTA1NywiZXhwIjoxNzgwNDkxMDU3LCJqdGkiOjE3ODA0OTEwNTcxMjMsImF1ZCI6InZpc2lvbiJ9.LxnfoBZUT_2c6PLgFrNCGi6PUTxKbaIX1UY6RRNw1gs",
    "logo_empresa": "https://cdn-vulcan-us.s3.amazonaws.com/vision/logo_empresa_remax.png",
    "logo_empresa_light": "https://cdn-vulcan-us.s3.amazonaws.com/vision/logo_empresa_remax.png",
    "logo_empresa_dark": "https://cdn-vulcan-us.s3.amazonaws.com/vision/logo_empresa_remax.png",
    "logo_empresa_small_light": "https://cdn-vulcan-us.s3.amazonaws.com/vision/logo_empresa_remax.png",
    "logo_empresa_small_dark": "https://cdn-vulcan-us.s3.amazonaws.com/vision/logo_empresa_remax.png",
    "favicon": "https://cdn-vulcan-us.s3.amazonaws.com/vision/favico_empresa.ico",
    "cover_login": "https://cdn-vulcan-us.s3.amazonaws.com/cartopay/cover_login.png",
    "gTagManager": "",
    "idHOTJAR": "",
    "appVersion": "0.0.1",
    "primaryColor": "#00D800",
    "secondaryColor": "#002C5D",
    "tertiaryColor": "#343a40",
    "quaternaryColor": "#f8f9fa",
    "successColor": "#28a745",
    "infoColor": "#17a2b8",
    "warningColor": "#ffc107",
    "dangerColor": "#dc3545",
    "url_facebook": "",
    "url_instagram": "",
    "url_linkedin": "",
    "ambient": "P"
  },

  {
    "name": "SharksPay",
    "identify": "sharkspay",
    "urlApi": "https://sharkspay.vulcan.net.br",
    "applicationCode": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJTSEFSS1NQQVkgTUVJT1MgREUgUEFHQU1FTlRPUyBMVERBIiwic3ViIjoiU0hBUktTUEFZIiwiaWF0IjoxNzgwNTA2MDc1LCJleHAiOjE3ODA1MDYwNzUsImp0aSI6MTc4MDUwNjA3NTEyMywiYXVkIjoic2hhcmtzcGF5In0.dMYrq1iQrUOS2QTWGN1FV4r-6fhVF1g31WoLrqFm3sc",
    "logo_empresa": "https://cdn-vulcan-us.s3.amazonaws.com/sharkspay/logo_empresa.png",
    "logo_empresa_light": "https://cdn-vulcan-us.s3.amazonaws.com/sharkspay/logo_empresa.png",
    "logo_empresa_dark": "https://cdn-vulcan-us.s3.amazonaws.com/sharkspay/logo_empresa.png",
    "logo_empresa_small_light": "https://cdn-vulcan-us.s3.amazonaws.com/sharkspay/logo_empresa.png",
    "logo_empresa_small_dark": "https://cdn-vulcan-us.s3.amazonaws.com/sharkspay/logo_empresa.png",
    "favicon": "https://cdn-vulcan-us.s3.amazonaws.com/sharkspay/favico_empresa.ico",
    "cover_login": "https://cdn-vulcan-us.s3.amazonaws.com/cartopay/cover_login.png",
    "gTagManager": "",
    "idHOTJAR": "",
    "appVersion": "0.0.1",
    "primaryColor": "#307ABD",
    "secondaryColor": "#002C5D",
    "tertiaryColor": "#343a40",
    "quaternaryColor": "#f8f9fa",
    "successColor": "#28a745",
    "infoColor": "#17a2b8",
    "warningColor": "#ffc107",
    "dangerColor": "#dc3545",
    "url_facebook": "",
    "url_instagram": "",
    "url_linkedin": "",
    "ambient": "P"
  },

  {
    "name": "Carto Fintech",
    "identify": "cartofintech",
    "urlApi": "https://vision.vulcan.net.br",
    "applicationCode": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJKVU5UT1MgTkVHXHUwMGQzQ0lPUyBFIEZSQU5DSElTTkcgTFREQSIsInN1YiI6IkpVTlRPUyIsImlhdCI6MTc4MzYxMzM1MSwiZXhwIjoxNzgzNjEzMzUxLCJqdGkiOjE3ODM2MTMzNTExMjMsImF1ZCI6InZpc2lvbiJ9.v2CB_OFU8EdrlKtmOpd3J_MMSTxI8t3SYA-Uc8A3qaI",
    "logo_empresa": "https://cdn-vulcan-us.s3.amazonaws.com/vision/logo_empresa.png",
    "logo_empresa_light": "https://cdn-vulcan-us.s3.amazonaws.com/vision/logo_empresa.png",
    "logo_empresa_dark": "https://cdn-vulcan-us.s3.amazonaws.com/vision/logo_empresa.png",
    "logo_empresa_small_light": "https://cdn-vulcan-us.s3.amazonaws.com/vision/logo_empresa.png",
    "logo_empresa_small_dark": "https://cdn-vulcan-us.s3.amazonaws.com/vision/logo_empresa.png",
    "favicon": "https://cdn-vulcan-us.s3.amazonaws.com/vision/favico_empresa.ico",
    "cover_login": "https://cdn-vulcan-us.s3.amazonaws.com/cartopay/cover_login.png",
    "gTagManager": "",
    "idHOTJAR": "",
    "appVersion": "0.0.1",
    "primaryColor": "#009917",
    "secondaryColor": "#002C5D",
    "tertiaryColor": "#343a40",
    "quaternaryColor": "#f8f9fa",
    "successColor": "#28a745",
    "infoColor": "#17a2b8",
    "warningColor": "#ffc107",
    "dangerColor": "#dc3545",
    "url_facebook": "",
    "url_instagram": "",
    "url_linkedin": "",
    "ambient": "P"
  },

  {
    "name": "FGS de Almeida",
    "identify": "fgs",
    "urlApi": "https://vision.vulcan.net.br",
    "applicationCode": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJKVU5UT1MgTkVHXHUwMGQzQ0lPUyBFIEZSQU5DSElTTkcgTFREQSIsInN1YiI6IkpVTlRPUyIsImlhdCI6MTc4MDQ5MTA0MCwiZXhwIjoxNzgwNDkxMDQwLCJqdGkiOjE3ODA0OTEwNDAxMjMsImF1ZCI6InZpc2lvbiJ9.fu2mgAZ7zVKSjhX9w9flvoX2yiqGzwqOt0ahC8vQlDk",
    "logo_empresa": "https://cdn-vulcan-us.s3.amazonaws.com/vision/logo_empresa.png",
    "logo_empresa_light": "https://cdn-vulcan-us.s3.amazonaws.com/vision/logo_empresa.png",
    "logo_empresa_dark": "https://cdn-vulcan-us.s3.amazonaws.com/vision/logo_empresa.png",
    "logo_empresa_small_light": "https://cdn-vulcan-us.s3.amazonaws.com/vision/logo_empresa.png",
    "logo_empresa_small_dark": "https://cdn-vulcan-us.s3.amazonaws.com/vision/logo_empresa.png",
    "favicon": "https://cdn-vulcan-us.s3.amazonaws.com/vision/favico_empresa.ico",
    "cover_login": "https://cdn-vulcan-us.s3.amazonaws.com/cartopay/cover_login.png",
    "gTagManager": "",
    "idHOTJAR": "",
    "appVersion": "0.0.1",
    "primaryColor": "#009917",
    "secondaryColor": "#002C5D",
    "tertiaryColor": "#343a40",
    "quaternaryColor": "#f8f9fa",
    "successColor": "#28a745",
    "infoColor": "#17a2b8",
    "warningColor": "#ffc107",
    "dangerColor": "#dc3545",
    "url_facebook": "",
    "url_instagram": "",
    "url_linkedin": "",
    "ambient": "P"
  },

  {
    "name": "Marco Polo",
    "identify": "marcopolo",
    "urlApi": "https://vision.vulcan.net.br",
    "applicationCode": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJKVU5UT1MgTkVHXHUwMGQzQ0lPUyBFIEZSQU5DSElTTkcgTFREQSIsInN1YiI6IkpVTlRPUyIsImlhdCI6MTc4MzYxMzQ3OSwiZXhwIjoxNzgzNjEzNDc5LCJqdGkiOjE3ODM2MTM0NzkxMjMsImF1ZCI6InZpc2lvbiJ9.3xj6-eAoyONcSTWmrUcvd25BbjA6w3s8nB21IOtd9Gc",
    "logo_empresa": "https://cdn-vulcan-us.s3.amazonaws.com/vision/logo_empresa.png",
    "logo_empresa_light": "https://cdn-vulcan-us.s3.amazonaws.com/vision/logo_empresa.png",
    "logo_empresa_dark": "https://cdn-vulcan-us.s3.amazonaws.com/vision/logo_empresa.png",
    "logo_empresa_small_light": "https://cdn-vulcan-us.s3.amazonaws.com/vision/logo_empresa.png",
    "logo_empresa_small_dark": "https://cdn-vulcan-us.s3.amazonaws.com/vision/logo_empresa.png",
    "favicon": "https://cdn-vulcan-us.s3.amazonaws.com/vision/favico_empresa.ico",
    "cover_login": "https://cdn-vulcan-us.s3.amazonaws.com/cartopay/cover_login.png",
    "gTagManager": "",
    "idHOTJAR": "",
    "appVersion": "0.0.1",
    "primaryColor": "#009917",
    "secondaryColor": "#002C5D",
    "tertiaryColor": "#343a40",
    "quaternaryColor": "#f8f9fa",
    "successColor": "#28a745",
    "infoColor": "#17a2b8",
    "warningColor": "#ffc107",
    "dangerColor": "#dc3545",
    "url_facebook": "",
    "url_instagram": "",
    "url_linkedin": "",
    "ambient": "P"
  },

  {
    "name": "Vision",
    "identify": "vision",
    "urlApi": "https://vision.vulcan.net.br",
    "applicationCode": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJKVU5UT1MgTkVHXHUwMGQzQ0lPUyBFIEZSQU5DSElTTkcgTFREQSIsInN1YiI6IkpVTlRPUyIsImlhdCI6MTc4MDUwNjM2MSwiZXhwIjoxNzgwNTA2MzYxLCJqdGkiOjE3ODA1MDYzNjExMjMsImF1ZCI6InZpc2lvbiJ9.LOp2GV9evf-FlKxkNTY0r4meQsUx9OhCT-EPdgfvx3I",
    "logo_empresa": "https://cdn-vulcan-us.s3.amazonaws.com/vision/logo_empresa.png",
    "logo_empresa_light": "https://cdn-vulcan-us.s3.amazonaws.com/vision/logo_empresa.png",
    "logo_empresa_dark": "https://cdn-vulcan-us.s3.amazonaws.com/vision/logo_empresa.png",
    "logo_empresa_small_light": "https://cdn-vulcan-us.s3.amazonaws.com/vision/logo_empresa.png",
    "logo_empresa_small_dark": "https://cdn-vulcan-us.s3.amazonaws.com/vision/logo_empresa.png",
    "favicon": "https://cdn-vulcan-us.s3.amazonaws.com/vision/favico_empresa.ico",
    "cover_login": "https://cdn-vulcan-us.s3.amazonaws.com/cartopay/cover_login.png",
    "gTagManager": "",
    "idHOTJAR": "",
    "appVersion": "0.0.1",
    "primaryColor": "#009917",
    "secondaryColor": "#002C5D",
    "tertiaryColor": "#343a40",
    "quaternaryColor": "#f8f9fa",
    "successColor": "#28a745",
    "infoColor": "#17a2b8",
    "warningColor": "#ffc107",
    "dangerColor": "#dc3545",
    "url_facebook": "",
    "url_instagram": "",
    "url_linkedin": "",
    "ambient": "P"
  }
]
 